import { getOrderItems } from './get-order-items';
export const getOrderItemsByItemId = (itemId, priceRestriction) => {
    return getOrderItems().filter(item => {
        if (item.itemId !== itemId)
            return false;
        return priceRestriction ? hasMatchingPriceRestriction(item, priceRestriction) : true;
    });
};
const hasMatchingPriceRestriction = (item, priceRestriction) => {
    if (item.discountId !== priceRestriction.discountId)
        return false;
    if (item.rewardId !== priceRestriction.rewardId)
        return false;
    return true;
};
